import { createModel } from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";
import {
  ProSkillManagerAssessmentStatusType
} from "~~/package/mapper/proSkillManager/model/assessment/ProSkillManagerAssessmentStatusType";

export class ProSkillManagerAssessmentDetailInfoModel extends Model {
  constructor(
    public status: string = ProSkillManagerAssessmentStatusType.ENDED,
    public title: string = "",
    public startedAt: string = "",
    public endedAt: string = "",
    public duration: number = 0
  ) {
    super();
  }

  public static create(model: Partial<ProSkillManagerAssessmentDetailInfoModel>): ProSkillManagerAssessmentDetailInfoModel {
    return createModel<ProSkillManagerAssessmentDetailInfoModel>(ProSkillManagerAssessmentDetailInfoModel, {
      ...model
    });
  }
}
